import DiagService from "./DiagService";
import { to, setStateAsync } from "../react-lib/utils";

export default class DiagManager {
    getDiagRuleList = async ({apiToken, search, divisionId}) => {
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        if (search) {
            params.search = search;
        }
        if (divisionId) {
            params.division = divisionId;
        }
        const diagService = new DiagService();
        const [error, response] = await to(diagService.getDiagRuleList({ headers, params }));
        return [response, error];
    }

    getPatient = async ({apiToken}) => {
        let headers = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        const diagService = new DiagService();
        const [error, response] = await to(diagService.getPatient({ headers }));
        return [response, error];
    } 

    getMyDiagForm = async ({apiToken}) => {
        let headers = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        const diagService = new DiagService();
        const [error, response] = await to(diagService.getMyDiagForm({ headers }));
        return [response, error];
    } 

    createDiagForm = async ({apiToken, patient, diagRule, answers, triageLevel, finished, text, duplicate}) => {
        let headers = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        let data = {
            patient: patient,
            published_diag_rule: diagRule,
            answers: answers,
            triage_level: triageLevel,
            finished: finished,
            allow_duplicate: duplicate,
            text
        }
        const diagService = new DiagService();
        const [error, response] = await to(diagService.postDiagForm({ headers, data }));
        return [response, error];
    }

    updateDiagForm = async ({apiToken, diagFormId, answers, finished, triageLevel, text}) => {
        let headers = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        let data = {
            id: diagFormId,
            answers: answers,
            finished: finished,
            triage_level: triageLevel,
            text: text,
        }
        console.log("updateDiagForm Request: ",JSON.stringify(data));
        const diagService = new DiagService();
        const [error, response] = await to(diagService.patchDiagFormId({ diagFormId, headers, data }));
        console.log("updateDiagForm response: ",JSON.stringify(response));
        console.log("updateDiagForm response: ",JSON.stringify(error));
        return [response, error];
    }

    getTriageLevelWithDivision = async ({apiToken, division, triageLevel}) => {
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        if (triageLevel) {
            params.triage_level = triageLevel;
        }
        const diagService = new DiagService();
        const [error, response] = await to(diagService.getTriageLevelWithDivision({ division, headers, params }));
        return [response, error];
    }

    createEncounterWithDiagForm = async ({apiToken, diagFormId}) => {
        let headers = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        let data = {
            diag_form: diagFormId,
        }
        const diagService = new DiagService();
        const [error, response] = await to(diagService.postCreateEncounterFromDiagForm({ headers, data }));
        return [response, error];
    }

    /** Division Profile */
    getDivisionProfileWithID = async ({apiToken, divisionId}) => {
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        const diagService = new DiagService();
        const [error, response] = await to(diagService.getDivisionProfileWithID({ divisionId, headers, params }));
        return [response, error];
    }

    getPublishDiagRuleDetail = async ({ apiToken, publishDiagRuleId } = {}) => {
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        const diagService = new DiagService();
        const [error, response, network] = await to(diagService.getPublishDiagRuleDetail({ publishDiagRuleId, headers, params }));
        return [response, error, network];
    }

    getProxyPatientHasDivision = async ({ apiToken } = {}) => {
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        const diagService = new DiagService();
        const [error, response, network] = await to(diagService.getProxyPatientHasDivision({ headers, params }));
        return [response, error, network];
    }

    getPublishDiagRuleCheck = async ({ apiToken, divisionId, code, diagRule } = {}) => {
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        if(divisionId){
            params.division = divisionId
        }
        if(code){
            params.code = code
        }
        if (diagRule) {
            params.diag_rule = diagRule;
        }
        const diagService = new DiagService();
        const [error, response, network] = await to(diagService.getPublishDiagRuleCheck({ headers, params }));
        return [response, error, network];
    }

    getDiagFormDetail = async ({ apiToken, diagFormId } = {}) => {
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        const diagService = new DiagService();
        const [error, response, network] = await to(diagService.getDiagFormDetail({ headers, params, diagFormId }));
        return [response, error, network];
    }

    getListConsents = async ({ apiToken } = {}) => {
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        const diagService = new DiagService();
        const [error, response, network] = await to(diagService.getListConsents({ headers, params }));
        return [response, error, network];
    }
    getV3PatientHospital = async ({ apiToken } = {}) => {
        let lang = undefined;
        if (window.mobile.iOSLang) {
            lang = window.navigator?.language;
        }
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        if (lang) {
            headers["Accept-Language"] = lang;
        }
        const diagService = new DiagService();
        const [error, response, network] = await to(diagService.getV3PatientHospital({ headers, params }));
        return [response, error, network];
    }

    getV3PatientGetHn = async ({ apiToken } = {}) => {
        let lang = undefined;
        if (window.mobile.iOSLang) {
            lang = window.navigator?.language;
        }
        let headers = {}
        let params = {}
        if (apiToken) {
            headers.Authorization = `Token ${apiToken}`;
        }
        if (lang) {
            headers["Accept-Language"] = lang;
        }
        const diagService = new DiagService();
        const [error, response, network] = await to(diagService.getV3PatientGetHn({ headers, params }));
        return [response, error, network];
    }


}